<template>
    <div>
    <div class="container-fluid">
      <vx-card title="Reportes de círculo de crédito" class="mt-5" subtitle="Selecciona las opciones necesarias y presiona el botón 'Consultar'">
          <vs-row>
            <vs-col vs-lg="2" vs-sm="6" vs-xs="12">
                <vs-select
                    class="w-full mb-4"
                    label="Mes de corte"
                    v-model.lazy="periodSelected"
                    name="periodSelected"
                    placeholder="Seleccione una opción"
                >
                    <vs-select-item
                    :key="index"
                    :value="index+1"
                    :text="item"
                    v-for="(item,index) in months"
                    class="w-full"
                    />
                </vs-select>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="6" vs-xs="12" class="ml-2">
                <vs-select
                    class="w-full mb-4"
                    label="Año"
                    v-model.lazy="yearSelected"
                    name="yearSelected"
                    placeholder="Seleccione una opción"
                >
                    <vs-select-item
                    :key="index"
                    :value="index"
                    :text="item"
                    v-for="(item,index) in years"
                    class="w-full"
                    />
                </vs-select>
            </vs-col>
            <vs-col vs-lg="7" vs-sm="12" vs-xs="12" class="ml-4">
                <div class="flex flex-wrap mt-6">
                    <vs-button color="success" @click="loadReports(false)" :disabled="loading">Consultar</vs-button>
                    <vs-button color="dark" class="ml-2" @click="loadReports(true)" :disabled="loading">Mostrar todos</vs-button>
                    <vx-tooltip text="Se muestran los proyectos liquídados y con cobranza concluida.">
                      <vs-button color="danger" class="ml-2" @click="loadFinishedProjects" :disabled="loading">No incluidos</vs-button>
                    </vx-tooltip>
                </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12">
              <h5 class="bold mt-5">Reportes generados</h5>
              <vs-table
                :sst="true"
                @sort="handleSort"
                ref="table"
                stripe
                :max-items="30"
                :data="allReports"
                noDataText="No hay datos disponibles"
                class="w-full"
              >
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                  <div class="pager" v-if="allReports.length > 0">
                    <div class="flex flex-wrap">
                      <vs-button
                        :disabled="allData.prev_page_url ? null:true"
                        type="border"
                        radius
                        @click="pager(allData.prev_page_url)"
                        class="mr-2"
                        icon-pack="feather"
                        icon="icon-chevron-left"
                      ></vs-button>
                      <vs-button
                        v-if="allData.prev_page_url != null"
                        text-color="#212121"
                        type="flat"
                        radius
                        @click="pager(allData.first_page_url)"
                        class="rounded-circle mr-2"
                      >
                        <strong>1 ..</strong>
                      </vs-button>
                      <vs-button type="flat" text-color="dark" radius class="mr-2">
                        <strong>{{ allData.current_page }}</strong>
                      </vs-button>
                      <vs-button
                        v-if="allData.next_page_url != null"
                        text-color="#212121"
                        type="flat"
                        radius
                        @click="pager(allData.last_page_url)"
                        class="rounded-circle mr-2"
                      >
                        <strong>.. {{ allData.last_page }}</strong>
                      </vs-button>
                      <vs-button
                        :disabled="allData.next_page_url ? null:true"
                        type="border"
                        radius
                        @click="pager(allData.next_page_url)"
                        class="mr-2"
                        icon-pack="feather"
                        icon="icon-chevron-right"
                      ></vs-button>
                    </div>
                  </div>
                  <!-- ITEMS PER PAGE -->
                  <div
                    v-if="totalRecords > 0"
                    class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">{{ from }} - {{ to }} de {{ totalRecords }}</span>
                  </div>
                </div>
                <template slot="thead">
                  <vs-th
                    class="bold"
                    v-for="(col, idx) in columns"
                    v-bind:key="idx"
                    :sort-key="col.sortable ? col.key : null"
                  >{{col.title}}</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td>{{ tr.id }}</vs-td>
                    <vs-td>{{ midDateFormat(tr.created_at) }}</vs-td>
                    <vs-td>{{ tr.period }}</vs-td>
                    <vs-td v-if="tr.pm_pfae">
                      <h5 class="badge badge-success" style="border-radius: .500rem;width: 40%;font-size:100%;">P. Moral</h5>
                    </vs-td>
                    <vs-td v-else>
                      <label class="badge badge-dark" style="border-radius: .500rem;width: 40%;font-size:100%;">P. Física</label>
                    </vs-td>
                    <vs-td><vs-button size="small" color="success" type="filled" icon="download" @click="downloadFile(tr)">Descargar</vs-button></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-col>
          </vs-row>
      </vx-card>
    </div>
    <vs-popup title="Pagados/Cobranza concluida (del mes anterior a la fecha)" :active.sync="showDialog">
        <vs-table
          ref="projectsTable"
          stripe
          :data="finishedProjects"
          noDataText="No hay datos disponibles"
        >
          <template slot="thead">
            <vs-th>PID</vs-th>
            <vs-th>Alias</vs-th>
            <vs-th>UID</vs-th>
            <vs-th>Estatus</vs-th>
            <vs-th>Fecha de liquidación/conclusión</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="indextr"
              v-for="(tr, indextr) in data"
              :data="tr"
            >
              <vs-td class="small bold"><a :href="$sanitizeUrl('/cobranza/' + tr.id)" target="blank">{{tr.id}}</a></vs-td>
              <vs-td class="small">{{ tr.alias }}</vs-td>
              <vs-td class="small">{{ tr.user_id }}</vs-td>
              <template v-if="tr.debt_settlement_date">
                <vs-td class="small">Pagado</vs-td>
                <vs-td class="small">{{ midDateFormat(tr.debt_settlement_date) }}</vs-td>
              </template>
              <template v-else>
                <vs-td class="small">Cobranza concluida</vs-td>
                <vs-td class="small">{{ midDateFormat(tr.concluded_collection_date) }}</vs-td>
              </template>
            </vs-tr>
          </template>
        </vs-table>
    </vs-popup>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import dateHelper from "@mixins/dateHelper";
    const columnDefinitions = [
        { title: "ID", key: "id", sortable: false },
        { title: "Fecha de creación", key: "created_at", sortable: true },
        { title: "Periodo", key: "period", sortable: false },
        { title: "Tipo de Reporte", key: "report", sortable: false },
        { title: "Archivo", key: "pm_pfae", sortable: false },
    ];
    export default {
        name: "SIC.vue",
        mixins: [dateHelper],
        computed: {
            ...mapState('auth', ['user']),
            allReports() {
                return this.allData.data;
            },
            from() {
                return this.allData.from;
            },
            to() {
                return this.allData.to;
            },
            totalRecords() {
                return this.allData.total;
            }
        },
        data: () => ({
            loading: false,
            months: ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
            years: ["2020","2021","2022","2023"],
            periodSelected: 1,
            yearSelected: 0,
            allData: {
                data: [],
                from: null,
                to: null,
                total: 0
            },
            finishedProjects: [],
            showDialog: false,
            columns: columnDefinitions,
        }),
        async mounted() {
            await this.loadReports();
        },
        methods: {
            async loadReports(showAll = true, url = '/api/reports/sic/all/all') {
                this.showLoading(true);
                if (showAll === false) {
                    var year = this.years[this.yearSelected];
                    url = `/api/reports/sic/${this.periodSelected}/${year}`;
                }
                try {
                    const response = await axios.get(url);
                    this.allData = response.data;
                    this.showLoading(false);
                } catch (e) {
                this.showLoading(false);
                    this.errorNotif("Aviso", e.response.data.message, 4000);
                }
            },
            downloadFile(report) {
                window.open(`${this.ApiDomain}/api/downloadCiReport/${report.id}?access_token=${this.AccessToken}`, "_blank");
            },
            async loadFinishedProjects() {
                this.showLoading(true);
                try {
                    const response = await axios.get(`/api/reports/sic/finishedProjects`);
                    this.finishedProjects = response.data;
                    this.showLoading(false);
                    this.showDialog = true;
                } catch (e) {
                  this.showLoading(false);
                  this.errorNotif("Aviso", e.response.data.message, 4000);
                }
            },
            async handleSort(key, active) {
                if (key === "created_at") {
                    this.allReports.sort(function (a, b) {
                    return (
                        Number(new Date(a.created_at)) - Number(new Date(b.created_at))
                    );
                    });
                }
            },
            async pager(url) {
                await this.loadReports(null,url);
            },
        }
    }
</script>